import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {CModule} from 'shared/models/cmodules/cmodule';
import {ICModulesDetailsRepository} from '../repositories/cmodules-details.repository.interface';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Content } from 'shared/models/contents/content';

@Injectable()
export class CModulesDetailsService {

  constructor(@Inject('ICModulesDetailsRepository') private cmodulesDetailsRepository: ICModulesDetailsRepository) { }

  public getCModules(): Observable<Array<CModule>> {
    return this.cmodulesDetailsRepository.getCModules();
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.cmodulesDetailsRepository.getAllTargetGroups();
  }

  public getContents(): Observable<Array<Content>> {
    return this.cmodulesDetailsRepository.getContents();
  }

  public getCModule(id: string): Observable<CModule> {
    return this.cmodulesDetailsRepository.getCModule(id);
  }

  public saveCModule(cmodule: CModule): Observable<CModule> {
    return this.cmodulesDetailsRepository.saveCModule(cmodule);
  }

  public updateCModule(cmodule: CModule): Observable<CModule> {
    return this.cmodulesDetailsRepository.updateCModule(cmodule);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-details/services/cmodules-details.service.ts